<div class="image-drawer-container">
    <div class="image" *ngFor="let image of data" [ngClass]="image.style">
        <div class="copy" *ngIf="image.title">
            <span class="title">{{image.title}}</span>
            <span *ngIf="image.subtitle" class="subtitle">{{image.subtitle}}</span>
        </div>
        <finder-picture
            [picture]="image.picture">
        </finder-picture>
    </div>
</div>
